module.exports = __webpack_public_path__ + "img/success_OLD_e.39e83b63.gif";